module.exports = __webpack_public_path__ + "static/media/purchaseOrderOutgoing.60787313.svg";